// ─── Feature Announcements ───────────────────────────────────────────────────
// Each announcement is self-contained. After expiresAt it never shows, even if
// the dismiss cookie was cleared.
// TODO(MEETEX-282998): Remove whos_who entry after adoption reaches target.
export const ANNOUNCEMENTS = {
  WHOS_WHO: {
    dismissKey: "aims_whoswho_announcement_dismissed",
    metricPrefix: "WhosWho_Announcement",
    lines: [
      "Curious who you're meeting with?",
      'Try {{action}} to get the scoop.',
    ],
    actionLabel: '"Who\'s who"',
    expiresAt: 1798070400000, // 2026-12-24
  },
};
